import { render, staticRenderFns } from "./CustomFilterItem.vue?vue&type=template&id=2f5280dc&"
import script from "./CustomFilterItem.vue?vue&type=script&lang=js&"
export * from "./CustomFilterItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports